export default __webpack_public_path__ + "static/profile-pic-1-23eba28b3034bdcc84ace73b187de484.jpeg";